export const MEMO_PART_DELIMITER = ':'
